<script>
import { mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
const api = ClientFactory.get("briefings");
import UploadFile from '../../../components/files/Upload.vue';
import { VueGoodTable } from "vue-good-table";

export default {
    components: {
        UploadFile,
        VueGoodTable
    },
    data() {
        return {
            dataModel: "",
            inputContent: "",
            inputYear: new Date().getFullYear(),
            inputMonth: new Date().getMonth() + 1,
            inputFile: null,
            dialog: {
                active: false
            },
            attachments: {
                files: [],
            },
            listFiles:[]
        };
    },
    methods: {
        ...mapActions("ui", ["loading", "closeLoading", "notify"]),
        async update() {
            this.$validator.validateAll();
            if (!this.validator()) {
                return this.notify({
                    error: true,
                    text: "Dữ liệu không hợp lệ.",
                });
            }
            
            
            this.dataModel.content = this.inputContent;
            this.dataModel.briefings_year = this.inputYear;
            this.dataModel.briefings_month = this.inputMonth;

            let attachmentIds = this.listFiles.map(f => {
                return f.id
            })
            attachmentIds = attachmentIds.concat(this.attachments.files)
            this.dataModel.file_id = attachmentIds;
            if(attachmentIds.length == 0) {
                return this.notify({
                    error: true,
                    text: 'Tệp tin đính kèm là bắt buộc',
                });
            }
            this.loading(this.$vs);

            let response = await api.updConclusion(this.dataModel);
            if (
                typeof response.error !== "undefined" ||
                response.data.status === "failed"
            ) {
                this.closeLoading();
                return this.notify({
                    error: true,
                    text: response.error || response.data.message,
                });
            } else {
                this.$router.back();
                this.closeLoading();
                return this.notify({
                    text: "Cập nhật dữ liệu thành công",
                });
            }
        },
        validator() {
            return (
                !this.errors.any() &&
                this.inputContent !== "" &&
                this.inputYear !== ""
            );
        },
        displayUploadDialog() {
            this.dialog.active = true;
        },
        uploadDone() {
            this.dialog.active = false;
            this.attachments.files = this.attachments.files.concat(this.$refs.uploadDialog.fileIds.map(f=> parseInt(f)));
        },
        removeFile(file) {
            this.listFiles = this.listFiles.filter(f => f.id !== file.id)
        },
    },
    async created() {
        let id = this.$route.params.id;
        this.loading(this.$vs);
        let response = await api.searchConclusion(id, "", "");
        if (
            typeof response.error !== "undefined" ||
            response.status === "failed"
        ) {
            this.closeLoading();
            this.notify({
                error: true,
                text: response.error || response.message,
            });
            return this.$router
                .push("/briefingsconclusion/list/")
                .catch(() => {});
        }
        this.dataModel = response.data.data[0];
        this.inputContent = this.dataModel.content;
        this.inputYear = this.dataModel.briefings_year;
        this.inputMonth = this.dataModel.briefings_month;

        this.listFiles = (await api.getfileConclusion(id)).data;
        this.closeLoading();
    },
    destroyed() {
        this.closeLoading();
    },
    computed: {
        file_columns() {
            return [
                {
                    label: "Tên tệp tin",
                    field: "file_name",
                    thClass: "emu-vgt-thead-th",
                    tdClass: "emu-vgt-tbody-td",
                },
                {
                    label: "Hành động",
                    field: "action",
                    thClass: "emu-vgt-thead-th text-center width-status",
                    tdClass: "emu-vgt-tbody-td text-center width-status",
                    width: "100px",
                },
            ]
        }
    },
};
</script>
<template>
    <div id='briefings-conclusion-edit'>
        <CCard>
            <CCardHeader>
                <span class="card-header-title">Cập nhật kết luận giao ban</span>
            </CCardHeader>
            <CCardBody>
                <CRow class="mb-2">
                    <CCol md="12">
                        <CInput
                            v-model="inputContent"
                            label="Tên báo cáo"
                            v-validate="'required'"
                            name="Tên báo cáo"
                        />
                        <span class="text-danger text-sm">{{
                            errors.first("Tên báo cáo")
                        }}</span>
                    </CCol>
                </CRow>
                <CRow class="mb-2">
                    <CCol md="3">
                        <CInput
                            v-model="inputYear"
                            type="number"
                            label="Năm"
                            v-validate="'required'"
                            name="Năm"
                        />
                        <span class="text-danger text-sm">{{
                            errors.first("Năm")
                        }}</span>
                    </CCol>
                    <CCol md="3">
                        <CSelect
                            :value.sync="inputMonth"
                            label="Tháng"
                            :options="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                        />
                    </CCol>
                    <CCol md="3">
                        <span>File đính kèm (*)</span>
						<vs-button class="mt-2 ml-0" square danger @click="displayUploadDialog"><i class="bx bx-cloud-upload"></i> &nbsp; Chọn files</vs-button>
						<span v-if="this.attachments.files.length > 0" style="color: #2eb85c" class="small">Đã tải lên {{this.attachments.files.length}} tệp tin</span>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="12" class="mb-2"><span>File đính kèm hiện tại</span></CCol>
                </CRow>
				<vue-good-table
                        :columns="file_columns"
                        :rows="listFiles"
                        :sort-options="{
                            enabled: false,
                        }"
                >
					<div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
						Không có dữ liệu
					</div>
					<template slot="table-row" slot-scope="props" >
						<div v-if="props.column.field === 'action'" class="row">
							<vs-button v-b-tooltip.hover transparent circle icon>
								<CLink :href="props.row.file_path" target="_blank">
									<span><i class="bx bx-download"></i></span>
								</CLink>
							</vs-button>
							<vs-button v-b-tooltip.hover transparent circle icon danger @click="removeFile(props.row)"><i class='bx bx-x'></i></vs-button>
						</div>
					</template>
                </vue-good-table>
                
            </CCardBody>
            <CCardFooter>
                <CRow>
                    <CCol md="12">
                        <div class="text-center">
                            <vs-button
                                class="d-inline custom_btn_search"
                                square
                                danger
                                @click="$router.back()"
                                ><i class='bx bx-left-arrow-alt'></i>&nbsp; Quay lại</vs-button
                            >
                            <vs-button class="d-inline" square @click="update"
                                ><i class='bx bxs-save'></i>&nbsp; Cập nhật</vs-button
                            >
                        </div>
                    </CCol>
                </CRow>
            </CCardFooter>
        </CCard>
        <vs-dialog prevent-close width="600px" scroll overflow-hidden v-model="dialog.active">
            <template #header>
                <h4 class="not-margin">
                <b>Tải lên</b>
                </h4>
            </template>
            <UploadFile ref="uploadDialog"/>
            <template #footer>
                <div class="con-footer flex flex-end">
                    <vs-button square success @click="$refs.uploadDialog.uploadFiles()"><i class="bx bx-cloud-upload"></i> &nbsp; Bắt đầu tải</vs-button>
                    <vs-button square danger @click="uploadDone"><i class="bx bx-save"></i> &nbsp; Xong</vs-button>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>

<style lang="scss">
    #briefings-conclusion-edit {
        .form-control-file {
            margin-top: 5px;
        }
        .vgt-responsive {
			overflow-x: inherit;
		}
		table.vgt-table td {
			vertical-align: inherit;
			padding: 0em 0.75em 0em 0.75em;
		}
    }
</style>